import React from "react";
import { Link } from "react-router";
import { Checkbox, CircularProgress, RaisedButton } from "material-ui";
import assign from "lodash/assign";
import chunk from "lodash/chunk";
import { colors } from "material-ui/styles";
import Helmet from "react-helmet";
import api from "../utils/api";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../actions/PersonActions";
import PersonStore from "../stores/PersonStore";

import { capitalize, formatPrice, isApp } from "../util";
import InjectedTenantHTML from "./partials/injected-tenant-html.jsx";

@connectToStores
class RequestAccountDeletion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      isChecked: false,
      requestCompleted: false,
      error: null
    };

    this.getStyles = this.getStyles.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleDeleteRequest = this.handleDeleteRequest.bind(this);
  }

  static get contextTypes() {
    return {
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object,
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      isLarge: React.PropTypes.bool
    };
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  static componentDidConnect(props, context) {
    if (!PersonStore.isLoggedIn()) {
      context.router.replace({
        pathname: "/login",
        query: { next: "/account/request-delete" },
        state: {}
      });
    }
  }

  getStyles() {
    let primaryColor = this.context.muiTheme.rawTheme.palette.primary1Color,
      { isLarge } = this.context;

    return {
      loading: {
        padding: "30px 10px",
        textAlign: "center"
      },
      appMessage: {
        padding: 10,
        paddingTop: 30,
        textAlign: "center",
        fontSize: "12pt"
      },
      container: {
        padding: 10
      },
      title: {
        textAlign: "center",
        fontSize: 30
      },
      deleteContainer: {
        display: "flex",
        flexWrap: "wrap"
      },
      completeContainer: {
        textAlign: "center",
        marginTop: 20,
        marginBottom:10,
        fontSize: "1.10em",
        fontWeight: "bold"
      },
      deleteButton: {
        marginRight: 10,
        marginTop: 15,
        minWidth: 90,
        height: 50
      },
      deleteButtonLabel: {
        fontSize: "1.25em"
      },
      requestDeletionError: {
        marginTop: 20,
        marginBottom:10,
        fontSize: "1.10em",
        fontWeight: "bold",
        color: "#f00"
      }
    };
  }

  handleCheckboxClick(e) {
    this.setState({ isChecked: e.target.checked, error: null });
  }

  handleDeleteRequest() {

    if (!this.state.isChecked) {
      this.setState({ error: "Please confirm your request by selecting the checkbox." });
      return;
    }

    api.request(
        {
          method: "POST",
          endpoint: `accounts/request_delete/${PersonStore.getPersonId()}`,
          api_key: PersonStore.getState().token
        },
        function (err, response) {
          if (err) {
            this.setState({ error: err.message });
          }
          else {
            this.setState({ requestCompleted: true });
          }
        }.bind(this)
      );
  }

  render() {

    let styles = this.getStyles();  

    return (
      <div>
        <Helmet title="Request Account Deletion" />

        <div style={styles.container}>
          <h2 style={styles.title}>Request Account Deletion</h2>
          {!this.state.requestCompleted ? (
            <div>
              <div style={styles.deleteContainer}>
                <Checkbox 
                  value={this.state.isChecked} 
                  label="I confirm that I am requesting to have all of my personal account data removed and my account closed."
                  onClick={this.handleCheckboxClick}
                />
              </div>
              <div>
                <RaisedButton 
                  style={styles.deleteButton}
                  labelStyle={styles.deleteButtonLabel}
                  label="Make Request"
                  primary={true}
                  onClick={this.handleDeleteRequest}
                />
              </div>
              {this.state.error 
                ? (<div style={styles.requestDeletionError}>{this.state.error}</div>)
                : null
              }
            </div>
          )
        : (
          <div style={styles.completeContainer}>
            Your request has been sent. Please allow 1-3 business days for processing.
          </div>
        )}
        </div>
      </div>
    );
  }
}

export default RequestAccountDeletion;



// WEBPACK FOOTER //
// ./src/app/components/request-account-deletion.jsx